import { css } from "glamor";
import React from "react";
import { Page, Link, Button, spacing } from "../library";
import QuestionContainer from "../questions/QuestionContainer";
import MockTimer from "./MockTimer";
import { typographyColors } from "../library/theme";
import { useMonitorScreen } from "../../utils/useScreenWidth";
import MockPreferecencesContainer from "./MockPreferencesModalContainer";

const actionsClass = css({
  display: "flex",
  gap: spacing.m,
  overflowX: "auto",
  scrollbarWidth: "none",
  "::-webkit-scrollbar": {
    display: "none",
  },
  marginBottom: spacing.m,
});

// Rendered inside the page header (see the `actions` prop below). Below 1200px
// the header is too tight for it, so MockSidebar takes over the timer there
// (it mirrors this breakpoint through `showTimer={!isMonitor}`).
const mockTimerClass = css({
  display: "flex",
  justifyContent: "right",
  lineHeight: 1,
});

const timeTextStyle = {
  color: typographyColors.blackLetters,
  fontSize: 16,
  whiteSpace: "nowrap",
};

export default function Mock({ mock }) {
  const isMonitor = useMonitorScreen();
  const canViewResults = !!mock?.finishedAt && !!mock?.results;
  const canViewRanking =
    canViewResults && !mock?.exam && !!mock?.mockTemplateId;

  return (
    <Page
      title={mock?.title}
      actions={
        isMonitor && (
          <MockTimer
            className={mockTimerClass}
            textStyle={timeTextStyle}
            createdAt={mock?.createdAt}
            finishedAt={mock?.finishedAt}
            showTimer
          />
        )
      }
    >
      <div className={actionsClass}>
        <>
          {canViewResults && (
            <Link component={Button} to={`/mocks/${mock?.id}/results`}>
              Ver Resultado
            </Link>
          )}
          {canViewRanking && (
            <Link component={Button} to={`/mocks/${mock?.id}/ranking`}>
              Ver Ranking
            </Link>
          )}
        </>
        {!mock?.exam && <MockPreferecencesContainer />}
      </div>

      <QuestionContainer />
    </Page>
  );
}
